export const truncateMiddle = (
  str?: string,
  {
    maxLength = 10,
    prefixLength = 5,
    suffixLength = 8,
  }: { maxLength?: number; prefixLength?: number; suffixLength?: number } = {},
) => {
  if (!str) return ''
  return str.length > maxLength
    ? `${str.slice(0, prefixLength)}...${str.slice(-suffixLength)}`
    : str
}
